exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearcart-btn[data-v-1af985ac]{display:flex;align-items:center}\n", ""]);

// exports
